module.exports = __webpack_public_path__ + "static/media/太原学院新校区综合供暖项目1.4ada0c2b.jpg";